import React, { FC, useEffect, useState } from 'react';
import { AlertColor, Box, Tabs, Tab, CircularProgress, useTheme, Grid } from '@mui/material';
import Notification from '../../../../../../components/Notification';
import strings from '../../../../../../common/Translation/Translate';
import { languages } from '../../../../../../utils/redux/reducer/authentication-slice';
import { useSelector } from 'react-redux';
import InputField from '../../../../../../components/InputField';
import Upload from '../../../../../../components/Upload/Upload';
import PrimaryButton from '../../../../../../components/Button/PrimaryButton';
import axiosInstance from '../../../../../../utils/axios';
import { URLS } from '../../../../../../utils/constants/urls';
import { useLocation, useParams } from 'react-router-dom';
import PageLoader from '../../../../../../components/PageLoader';
import Config from '../../../../../../utils/Config';
import { Validators } from 'utils/validators';
import { TabPanel } from 'utils/validators/HelperComponents';
type LocalizedAttributeProps = {
  dropdownData?: any;
  pageResponse: any;
  getPageData: (id: number) => void;
};

const LocalizedAttribute: FC<LocalizedAttributeProps> = ({ dropdownData, pageResponse, getPageData }) => {
  const theme = useTheme();
  const { id } = useParams() as any;
  const queryStings = useLocation().search as any;
  const queryStingId = new URLSearchParams(queryStings).get('id') as string;
  const languageList = useSelector(languages) as any;
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [focus, setFocus] = useState(true);
  const [filesMap, setFilesMap] = useState<any>([]);
  const [deletedFiles, setDeletedFiles] = useState<any>([]);
  const [deletetdContractTemplate, setDeletetdContractTemplate] = useState<any>([]);
  const [deletedTerms, setDeletedTerms] = useState<any>([]);
  const [deletedFloorPlan, setDeletedFloorPlan] = useState<any>([]);
  const [message, setMessage] = useState<{
    display: boolean;
    severity: AlertColor | null;
    message: string;
  }>({
    display: false,
    severity: null,
    message: '',
  });

  const setPageResponseHelper1 = (
    innerBookingPolicy: any,
    newObjectArray: any,
    innerContractTemplate: any,
    i: number,
  ) => {
    if (pageResponse.localizedAttributes[i].values.bookingPolicy) {
      innerBookingPolicy = {
        preview: pageResponse.localizedAttributes[i].values.bookingPolicy
          ? Config.BaseURL + pageResponse.localizedAttributes[i].values.bookingPolicy
          : null,
        name: pageResponse.localizedAttributes[i].values.bookingPolicyFileName,
        type: pageResponse.localizedAttributes[i].values.bookingPolicyFileType,
      };
      newObjectArray[i].values?.files?.push(innerBookingPolicy);
    }
    if (pageResponse.localizedAttributes[i].values.contractTemplate) {
      innerContractTemplate = {
        preview: pageResponse.localizedAttributes[i].values.contractTemplate
          ? Config.BaseURL + pageResponse.localizedAttributes[i].values.contractTemplate
          : null,
        name: pageResponse.localizedAttributes[i].values.contractTemplateFileName,
        type: pageResponse.localizedAttributes[i].values.contractTemplateFileType,
      };
      newObjectArray[i].values.contractTemplate.push(innerContractTemplate);
    }
  };
  const setPageResponseHelper2 = (innerFloorPlan: any, newObjectArray: any, innerTerms: any, i: number) => {
    if (pageResponse.localizedAttributes[i].values.floorPlan) {
      innerFloorPlan = {
        preview: pageResponse.localizedAttributes[i].values.floorPlan
          ? Config.BaseURL + pageResponse.localizedAttributes[i].values.floorPlan
          : null,
        name: pageResponse.localizedAttributes[i].values.floorPlanFileName,
        type: pageResponse.localizedAttributes[i].values.floorPlanFileType,
      };
      newObjectArray[i].values.floorPlan.push(innerFloorPlan);
    }
    if (pageResponse.localizedAttributes[i].values.terms) {
      innerTerms = {
        preview: pageResponse.localizedAttributes[i].values.terms
          ? Config.BaseURL + pageResponse.localizedAttributes[i].values.terms
          : null,
        name: pageResponse.localizedAttributes[i].values.termsFileName,
        type: pageResponse.localizedAttributes[i].values.termsFileType,
      };
      newObjectArray[i].values.terms.push(innerTerms);
    }
  };
  const setPageResponse = () => {
    const newObjectArray = [...filesMap];
    const arrayLength = pageResponse.localizedAttributes ? pageResponse.localizedAttributes.length : 0;
    for (let i = 0; i < arrayLength; i++) {
      let innerBookingPolicy = {};
      let innerContractTemplate = {};
      let innerFloorPlan = {};
      let innerTerms = {};
      newObjectArray.push({
        language: '',
        values: { files: [], contractTemplate: [], terms: [], floorPlan: [], description: '' },
      });

      newObjectArray[i].language = pageResponse.localizedAttributes[i].language;
      setPageResponseHelper1(innerBookingPolicy, newObjectArray, innerContractTemplate, i);
      setPageResponseHelper2(innerFloorPlan, newObjectArray, innerTerms, i);
      newObjectArray[i].values.description = pageResponse.localizedAttributes[i].values.description;
    }
    setFilesMap(newObjectArray);
  };

  useEffect(() => {
    if (pageResponse.localizedAttributes) {
      setPageResponse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const closeNotification = (value: boolean) => {
    setMessage({ ...message, display: value });
  };

  function idProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handletabChange = (e: any, languageValue: any) => {
    const newObject = [...filesMap] as any;
    let languagePresent = false;
    for (const element of newObject) {
      if (element.language === languageValue.value) {
        languagePresent = true;
        break;
      }
    }
    if (!languagePresent) {
      const language = languageValue.value;
      newObject.push({
        language,
        values: { files: [], contractTemplate: [], terms: [], floorPlan: [], description: '' },
      });
    }
    for (const element of newObject) {
      if (element.language === languageValue.value) {
        element.values.description = e.target.value || '';
      }
    }
    setFilesMap(newObject);
    setFocus(true);
  };

  const handleFileUpload = (
    files: any,
    field: string,
    error: any,
    deleted?: any,
    index?: number,
    languageData?: any,
  ) => {
    setFocus(false);
    const filesArray = files?.map((file: any) =>
      Object.assign(file, {
        mediaType: 'other',
      }),
    );
    if (Array.isArray(deleted)) {
      handleDeletedFile(index, languageData, 0, deleted);
    }
    const newObject = [...filesMap];
    let languagePresent = false;
    for (const element of newObject) {
      if (element.language === languageData.value) {
        languagePresent = true;
        break;
      }
    }
    if (!languagePresent) {
      const language = languageData.value;
      newObject.push({
        language,
        values: { files: [], contractTemplate: [], terms: [], floorPlan: [], description: '' },
      });
    }
    for (const element of newObject) {
      if (element.language === languageData.value) {
        switch (index) {
          case 1:
            element.values.files = filesArray;
            break;
          case 2:
            element.values.contractTemplate = filesArray;
            break;
          case 3:
            element.values.terms = filesArray;
            break;
          case 4:
            element.values.floorPlan = filesArray;
            break;

          default:
            break;
        }
      }
    }
    setFilesMap(newObject);
  };

  const handleCase1 = (element: any, itemValue: any) => {
    const files = element.values.files.splice(itemValue, 1);
    const deletedFile = files.filter((item: any, j: number) => itemValue === j);
    let deletedList = [...deletedFiles];
    if (deletedFile.length > 0 && deletedFile[0].name !== 0 && deletedFile[0].name !== undefined) {
      deletedList.push(deletedFile[0].name);
      setDeletedFiles(deletedList);
    }
  };
  const handleCase2 = (element: any, itemValue: any, index: any) => {
    const contractTemplate = element.values.contractTemplate.splice(itemValue, 1);
    const deletedContractTemplateList = contractTemplate.filter((item: any, j: number) => index === j);
    let deletedContractTemplateListData = [...deletetdContractTemplate];
    if (
      deletedContractTemplateList.length > 0 &&
      deletedContractTemplateList[0].name !== 0 &&
      deletedContractTemplateList[0].name !== undefined
    ) {
      deletedContractTemplateListData.push(deletedContractTemplateList[0].name);
      setDeletetdContractTemplate(deletedContractTemplateListData);
    }
  };
  const handleCase3 = (element: any, itemValue: any, index: any) => {
    const terms = element.values.terms.splice(itemValue, 1);
    const deletedTermsList = terms.filter((item: any, j: number) => index === j);
    let deletedTermsListData = [...deletedTerms];
    if (deletedTermsList.length > 0 && deletedTermsList[0].name !== 0 && deletedTermsList[0].name !== undefined) {
      deletedTermsListData.push(deletedTermsList[0].name);
      setDeletedTerms(deletedTermsListData);
    }
  };
  const handleCase4 = (element: any, itemValue: any, index: any) => {
    const floorPlan = element.values.floorPlan.splice(itemValue, 1);
    const deletedFloorPlanList = floorPlan.filter((item: any, j: number) => index === j);
    let deletedFloorPlanListData = [...deletedFloorPlan];
    if (
      deletedFloorPlanList.length > 0 &&
      deletedFloorPlanList[0].name !== 0 &&
      deletedFloorPlanList[0].name !== undefined
    ) {
      deletedFloorPlanListData.push(deletedFloorPlanList[0].name);
      setDeletedFloorPlan(deletedFloorPlanListData);
    }
  };
  const handleDeletedFile = (index: any, languageData?: any, itemValue = 0, deleted?: any) => {
    const newObject = [...filesMap];
    for (const element of newObject) {
      if (element.language === languageData.value) {
        switch (index) {
          case 1:
            handleCase1(element, itemValue);
            break;
          case 2:
            handleCase2(element, itemValue, index);
            break;
          case 3:
            handleCase3(element, itemValue, index);
            break;
          case 4:
            handleCase4(element, itemValue, index);
            break;
          default:
        }
      }
    }
  };
  const handleSubmit = async (e: any, language: any) => {
    try {
      const body = new FormData();
      for (const element of filesMap) {
        if (element.language === language) {
          body.append('description', element.values.description);
          body.append('priceDetails', '');
          body.append('priceSummary', '');
          body.append('bookingPolicy', element.values.files[0] || null);
          body.append('contractTemplate', element.values.contractTemplate[0] || null);
          body.append('terms', element.values.terms[0] || null);
          body.append('floorPlan', element.values.floorPlan[0] || null);
          body.append('deletedFloorPlan', deletedFloorPlan || '');
          body.append('deletetdContractTemplate', deletetdContractTemplate || '');
          body.append('deletedTerms', deletedTerms || '');
          body.append('deletedFiles', deletedFiles || '');
        }
      }
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      setLoading(true);
      const { status } = await axiosInstance.put(
        URLS.venueConfigsUpdateLocalizedAttributes(id || queryStingId, language),
        body,
        config,
      );
      if (status === 200) {
        getPageData(id || queryStingId);
        setMessage({
          display: true,
          severity: 'success',
          message: strings.common_update_message,
        });
        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
      if (e.response) {
        setMessage({
          display: true,
          severity: 'error',
          message: e.response?.data.message,
        });
      } else {
        setMessage({
          display: true,
          severity: 'error',
          message: e.message,
        });
      }
    }
  };

  return (
    <>
      {loading && <PageLoader />}
      {message.display && (
        <Notification
          isOpen={message.display}
          message={message.message}
          severity={message.severity as AlertColor}
          closeNotification={closeNotification}
        />
      )}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', p: 0 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="scrollable"
          allowScrollButtonsMobile
          scrollButtons="auto"
          sx={{
            '.MuiTabScrollButton-root.Mui-disabled': {
              display: 'none',
            },
          }}>
          {languageList?.map((item: any) => (
            <Tab key={item.value} label={item.text} {...idProps(item.value)} />
          ))}
        </Tabs>
      </Box>
      {languageList?.map((item: any, indexValue: number) => (
        <>
          <TabPanel key={item.value} value={indexValue} index={value}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <InputField
                  sx={{ mt: 2 }}
                  label={strings.venueConfig_attributes_description}
                  key={item.value}
                  autoFocus={focus}
                  validators={[{ check: Validators.validateString, max: 20 }]}
                  inputValue={
                    filesMap.find((e: any) => e.language === item.value)
                      ? filesMap.find((e: any) => e?.language === item?.value).values.description
                      : []
                  }
                  onChange={e => handletabChange(e, item)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Upload
                  label={strings.venueConfig_attributes_bookingPolicy}
                  field="files"
                  accept={'application/pdf'}
                  inputValue={
                    filesMap.find((e: any) => e.language === item.value)
                      ? filesMap.find((e: any) => e?.language === item?.value).values.files
                      : []
                  }
                  textChange={(value, field, error, deleted) => handleFileUpload(value, field, error, deleted, 1, item)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Upload
                  label={strings.venueConfig_attributes_contractTemplate}
                  field="contractTemplate"
                  accept={'text/html'}
                  inputValue={
                    filesMap.find((e: any) => e.language === item.value)
                      ? filesMap.find((e: any) => e?.language === item?.value).values.contractTemplate
                      : []
                  }
                  textChange={(value, field, error, deleted) => handleFileUpload(value, field, error, deleted, 2, item)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Upload
                  label={strings.venueConfig_attributes_terms}
                  field="terms"
                  accept={'application/pdf'}
                  inputValue={
                    filesMap.find((e: any) => e.language === item.value)
                      ? filesMap.find((e: any) => e?.language === item?.value).values.terms
                      : []
                  }
                  textChange={(value, field, error, deleted) => handleFileUpload(value, field, error, deleted, 3, item)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Upload
                  label={strings.venueConfig_attributes_floorPlan}
                  field="floorPlan"
                  accept={'image/*'}
                  inputValue={
                    filesMap.find((e: any) => e.language === item.value)
                      ? filesMap.find((e: any) => e?.language === item?.value).values.floorPlan
                      : []
                  }
                  textChange={(value, field, error, deleted) => handleFileUpload(value, field, error, deleted, 4, item)}
                />
              </Grid>
              <PrimaryButton
                disabled={loading}
                sx={{
                  minWidth: '100px',
                  '&.defaultButton': {
                    background: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                  },
                }}
                fullWidth={false}
                variant="contained"
                onClick={e => handleSubmit(e, item.value)}>
                {strings.common_button_save} {loading && <CircularProgress color="inherit" sx={{ ml: 1 }} size={20} />}
              </PrimaryButton>
            </Grid>
          </TabPanel>
        </>
      ))}
    </>
  );
};
export default LocalizedAttribute;
